import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=143e1424&scoped=true&"
import script from "./ButtonLink.vue?vue&type=script&lang=js&"
export * from "./ButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=143e1424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e1424",
  null
  
)

export default component.exports